export default {
  root: {
    backgroundColor: "#000",
    "& div": {
      fontWeight: "900 !important",
      minWidth: 100
    }
  }
}
